import { Component, ElementRef, OnInit, Input, ViewChild, Output, AfterViewInit, EventEmitter, ViewEncapsulation, Renderer2, ChangeDetectorRef } from '@angular/core';
import { State, CompositeFilterDescriptor, filterBy, aggregateBy } from '@progress/kendo-data-query';
import { GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DispatchCostAdjustmentBus } from '@app/cp/shared/models/DispatchCostAdjustmentBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { DispatchContAdjustmentBus } from '@app/cp/shared/models/DispatchContAdjustmentBus';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { DispatchCostAdjustmentsComponent } from '../dispatch-cost-adjustments/dispatch-cost-adjustments.component';
import { DispatchContractAdjustmentsComponent } from '../dispatch-contract-adjustments/dispatch-contract-adjustments.component';
import { DispatchCurrentCostAdjustmentsComponent } from '../dispatch-current-cost-adjustments/dispatch-current-cost-adjustments.component';
import { DispatchBtdAdjustmentsComponent } from '../dispatch-btd-adjustments/dispatch-btd-adjustments.component';
import { DispatchSixzerosixAdjustmentsComponent } from '../dispatch-sixzerosix-adjustments/dispatch-sixzerosix-adjustments.component';

/*******************************************************************************************************
 * Name: DispatchCostAdjustmentsComponent
 * Creator: GRG
 * Date: 20210330
 * OverridesAndExtras:
 *      1) addModeOnly input - can be used so that grid does not show and only popup window shows
 *      2) dispatchId set input property - if set then windows shows and saves with that id
 *      3) after set edit - used because there is no editing of this so set readonly to show as view
 *      4) originalReadOnly - so can return readonly to original state if viewing from grid
 *      5) customCanSaveForm - if code is 'Other' then require note
 * Notes:
 * Modified:
 *******************************************************************************************************/
@Component({
    selector: 'cp-dispatch-multi-adjustments',
    templateUrl: './dispatch-multi-adjustments.component.html',
    styleUrls: ['./dispatch-multi-adjustments.component.scss'],
    standalone: false
})
export class DispatchMultiAdjustmentsComponent { //extends BaseGridEditFormLinesComponent<DispatchContAdjustmentBus, null, ConstructionService> {

    costCodeCF: MSCLFilterClass;

    @ViewChild('ContCostAdj') public contAdjComp: DispatchContractAdjustmentsComponent;
    @ViewChild('EstCostAdj') public costAdjComp: DispatchCostAdjustmentsComponent;
    @ViewChild('CurrCostAdj') public currCostAdjComp: DispatchCurrentCostAdjustmentsComponent;
    @ViewChild('BTDCostAdj') public BTDAdjComp: DispatchBtdAdjustmentsComponent;
    @ViewChild('SixZeroSixCostAdj') public SixZeroSixAdjComp: DispatchSixzerosixAdjustmentsComponent;

    formActive: boolean = false;
    @Input() referenceData: DQOIReferenceData;
    @Input() dataLoading: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() saveMode: any = SaveMode.individual;
    @Input() addModeOnly: boolean = false; //Do not show grid -
    @Input() multiAddMode: boolean = false; //Multiple Job Adjustment -
    private _dispatchId: any;
    @Input() set dispatchId(id: any) {
        //alert('multi: ' + id);
        this._dispatchId = id;
        if (CommonFunctions.hasGuidValue(id)) {
            this.formActive = true;
        }
    }
    get dispatchId() {
        return this._dispatchId;
    }
    private _jobIds: any;
    @Input() set jobIds(ids: any[]) {
        this._jobIds = ids;
        //alert('Multi JobIds: ' + JSON.stringify(ids));
    }
    get jobIds() {
        return this._jobIds;
    }
    private _jobNbrs: any;
    @Input() set jobNbrs(ids: any[]) {
        this._jobNbrs = ids;
        //alert('Multi jobNbrs: ' + JSON.stringify(ids));
    }
    get jobNbrs() {
        return this._jobNbrs;
    }
    cd: ChangeDetectorRef;
    adjustmentSaveMode: number = 1;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: ConstructionService) {
        this.cd = cd;
    }

    hideForm() {
        this.formActive = false;
    }
    cancelForm() {
        //this.closeEditor();
        this.hideForm();
        //this.close(false);
    }
    saveMultiForm() {
        if (this.contAdjComp.editForm.valid) {
            this.contAdjComp.saveForm();
        }
        if (this.costAdjComp.editForm.valid) {
            this.costAdjComp.saveForm();
        }
        if (this.currCostAdjComp.editForm.valid) {
            this.currCostAdjComp.saveForm();
        }
        if (this.BTDAdjComp.editForm.valid) {
            this.BTDAdjComp.saveForm();
        }
        if (this.SixZeroSixAdjComp.editForm.valid) {
            this.SixZeroSixAdjComp.saveForm();
        }
        //this.hideForm();
    }
    closeAdjustmentPopup() {

    }

}